import CategoryEdit from '../components/Categories/CategoryEdit'; // Assuming you have this component
import { t } from '../i18n';

export default function CategoryEditPage({ handleEditCategory }) {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Уреди категорија')}</h2>
      <CategoryEdit onAdd={handleEditCategory} />
    </>
  );
}
